<template>
    <div class="Payment">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>결제 내역</h2>

            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title clearfix">
                <div class="tab-menu pull-left width-85">
                    <ul>
                        <li :class="paymentTab == 'use' ? 'active' : ''"
                            @click="paymentTab='use'">
                            <a>사용권 현황</a>
                        </li>
                        <li :class="paymentTab == 'payment' ? 'active' : ''"
                            @click="paymentTab='payment'">
                            <a>결제내역</a>
                        </li>
                    </ul>
                </div>
            </h2>
            <!-- 사용권 현황 -->
            <div v-if="paymentTab == 'use'">
                <div class="payment-use mrg-top-20">
                    <h3>{{ strMyProductInfo }}</h3>
                    <h5>{{ strUsageStatus }}</h5>
                    <h4 v-html="strPeriodOfUse"></h4>
                </div>
            </div>
            <!-- 결제내역 -->
            <div v-else>
                <div class="form-box">
                    <div class="input-title"><span>검색기간</span></div>
                    <div class="input-box">
                        <div class="input-item">
                            <select v-model="searchMonth">
                                <option value="2020">2020년</option>
                                <option value="2019">2019년</option>
                                <option value="2018">2018년</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="mrg-top-20">
                    <table width="100%">
                        <colgroup>
                            <col width="65%" />
                            <col width="35%" />
                        </colgroup>
                        <thead>
                        <tr>
                            <th>내역</th>
                            <th>사용정보</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(data, index) in list" :key="index">
                            <td class="text-left pdd-left-10">
                                <div class="table-contents">
                                    <h3>{{ data.strProductName }}</h3>
                                    <h5>{{ data.nCostPrice | comma }}원</h5>
                                    <p> {{ data.strRegDate }}</p>
                                </div>
                            </td>
                            <td>
                                <div class="table-date">
                                    <strong>유효기간</strong>
                                    <p>{{data.strUsageInfo}}</p>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="text-center mrg-btm-20" v-if="list.length>0">
                        <paginate v-model="page"
                                  :page-count="totalPage"
                                  :prev-text="'<'"
                                  :next-text="'>'"
                                  :containerClass="'pagination'"
                                  :click-handler="changePage">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
    name: 'Payment',
    components: { Paginate },
    data() {
        return {
            paymentTab:'use',       // 선택된 Tab
            strMyProductInfo:'',    // 상품정보
            strUsageStatus:'',      // 상품상태
            strPeriodOfUse:'',      // 만료일 및 잔여정보
            searchMonth:2020,       // 결제내역 검색기간 정보
            list:[],                // 결제내역 리스트
            page:1,                 // 결제내역 페이지
            totalPage:1,            // 전체 페이지
        }
    },
    // 감시자
    watch: {
        // tab 변경
        paymentTab(_new){
            if (_new == 'use'){
                this.getPaymentMeSummary();
            }else{
                this.getPaymentMeHistory(1);
            }
        },
        // 검색기간 변경
        searchMonth(){
            this.getPaymentMeHistory(1);
        }
    },
    // $el 생성전
    created(){
        // 사용권현황
        this.getPaymentMeSummary();
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;

    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 사용권현황
        getPaymentMeSummary(){
            let param = {};
            this.ajaxGetAuth('/api/v1/payment/me/summary', param, this.getPaymentMeSummaryResult);
        },
        // 사용권현황 결과
        getPaymentMeSummaryResult(response){
            if (response.result.code == 0){
                this.strMyProductInfo = response.oPayment.summary.strMyProductInfo;
                this.strUsageStatus = response.oPayment.summary.strUsageStatus;
                this.strPeriodOfUse = response.oPayment.summary.strPeriodOfUse;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 결제내역
        getPaymentMeHistory(page){
            this.page = page;
            let param = {};
            this.ajaxGetAuth('/api/v1/payment/me/history/'+this.searchMonth+'/'+page, param, this.getPaymentMeHistoryResult);
        },
        // 결제내역 결과
        getPaymentMeHistoryResult(response){
            if (response.result.code == 0){
                this.list = response.oPayment.list;
                this.totalPage=response.oPayment.setting.nMaxPage;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 페이지 변경
        changePage(page){
            this.getPaymentMeHistory(page)
        },
    }
}
</script>

<style scoped>
    .payment-use { background-image:url("../../assets/images/bg-payment.png"); background-repeat: no-repeat; background-size: cover; padding: 20px 30px; border-radius: 15px; color: #fff;}
    .payment-use h3{font-size: 20px; font-weight: 600;}
    .payment-use h5{border: 1px solid #fff;display: inline-block;padding: 3px 10px;border-radius: 5px;margin: 5px 0 10px;font-weight: 300;font-size: 12px;}
    .payment-use h4{font-size: 14px; font-weight: 300}
    .payment-use h4 strong{font-weight: 500}

    .form-box {font-size: 13px;}
    .form-box select {height: 40px;font-size: 13px;}

    .table-gle-point {font-size: 16px; color: #8d8d8d; font-weight: 600}
    .table-gle-result {font-size: 16px; color: #0086ff; font-weight: 600}

</style>
